module.exports = __webpack_public_path__ + "static/media/decoration.68c68ea5.svg";